import { makeStyles } from "@material-ui/core/styles";
import salomone from '../../images/salomone_big.png';

const useStyleInsertForm = makeStyles((theme) => ({
  root: {
    /*'& .MuiFormControl-root': {
          width: '80%',
          margin: theme.spacing(1),
        },*/
  },
  leftColumn: {
    padding: "0 1% 0 1%",
    //borderRight: `dashed ${theme.palette.secondary.main} 3px`,
    borderRight: `dashed rgba(0, 0, 0, 0.1) 2px`,
  },
  rightColumn: {
    padding: "0 1% 0 1%",
  },
  leftColumnImg: {
    backgroundImage: `url("${salomone}")`,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    height: "75vh",
  },
  textField: {
    minWidth: "30%",
  },

  hrOriz: {
    marginTop: "2%",
    marginBottom: "2%",
    backgroundColor: theme.palette.primary.main,
  },

  boxBackground: {
    backgroundColor: "rgba(0, 0, 0, 0.05)",
    borderRadius: "3px",
    padding: "10px",
  },

  formControl: {
    margin: theme.spacing(1),
    minWidth: "30%",
  },
  formContent: {
    margin: theme.spacing(5),
    padding: theme.spacing(2),
  },
  itemSpacing: {
    margin: theme.spacing(1),
  },
  textArea: {
    width: "96%",
  },
  tableTags: {
    width: "100%",
    marginTop: "2%",
    margin: "auto",
  },
  tablePartner: {
    width: "42%",
    marginTop: "2%",
    margin: "auto",
  },
  spacing: {
    margin: theme.spacing(1),
  },
  inputItem: {
    width: "85%",
    marginTop: "2%",
  },
  titolo: {
    fontWeight: "500",
  },
}), { index : 1 }); // { index : 999 }) evita errore di posizionamento dei css con makestyles che altrimenti verrebbero dopo

export default useStyleInsertForm;
